import { UncontrolledDropdown } from "reactstrap"
import styled, { css } from "styled-components"
import { media } from "utils/Media"
 
const FilterDropdown = styled(UncontrolledDropdown)`
	margin-bottom: .5rem;
	position: relative;
	display: inline-block;
	z-index: 1;
	width: 100%;
	&:nth-child(2) {
		display: none;
	}
	@media ${media.md} {
		margin-bottom: 0;
		width: auto;
		margin-right: .5rem;
		
	}
	@media ${media.lg} {
		margin-right: 1rem;
		&:nth-child(4) {
			margin-top: 0 ;
		}
	}
	@media ${media.xl} {
		margin-right: 2rem;
	}


	button {
		min-width: 250px;
		border: 0;
		width: 100%;
		padding-right: 50px !important;
		display: flex;
		align-items: center;
		
		@media ${media.md} {
			width: auto;
		}
	}

	&.fullWidth {
		width: 100%;
		margin: 1rem 0 .5rem 0;
		
		button {
			width: 100%;
			min-width: 100%;
		}
		
		@media ${media.md} {
			width: 100%;
			margin: 1rem 0 .5rem 0;
		}
	}

	.dropdown-toggle {
		/* border: 1px solid black; */
		background-color: black;
		padding: .75rem;
		border-radius: 0;
		color: white;
		//font-style: italic;
		font-family: ${props => props.theme.font.family.heading};
		text-transform: uppercase;
		font-size: ${props => props.theme.font.size.sm};
		position: relative;
		text-align: left;
		padding-left: 1rem;
		/* border: 2px solid ${props => props.theme.colors.secondary}; */

		@media ${media.xl} {
			font-size: ${props => props.theme.font.size.base};
		}


		${props => props.tickets && css`
			background: transparent;
			border: solid 3px ${props => props.theme.colors.secondary};
			color: ${props => props.theme.colors.black};
			button {
				width: 50%;
			}
		`}
		&:after {
			display: none;
		}
		
		svg {
			position: absolute;
			right: 1rem;
			font-size: 1rem;
		}
	}

	.dropdown-menu {
		margin: 0;
		padding: 0;
		width: 100%;
		border-top: 0 !important;
		top: -1px !important;
		overflow: hidden;	
		button {
			color: black;
			text-transform: uppercase;
			font-family: ${props => props.theme.font.family.heading};
			font-size: ${props => props.theme.font.size.sm};
			padding: .5rem 1rem;
			border: 0;
			&:hover {
				color: ${props => props.theme.colors.white};
				background-color: ${props => props.theme.colors.primary};
			}
		}
		${props => props.tickets && css`
			border: solid 3px ${props => props.theme.colors.secondary}!important;
			border-top: none!important;
			font-style: italic!important;
			
		`}
	}

	.dropdown-item {
		white-space: unset;
		${props => props.tickets && css`
			font-style: italic!important;
			text-align: center;
			font-size: ${props => props.theme.font.size.base};

		`}
		
	}

	&.show {
		z-index: 10;
		.dropdown-toggle {
			border-bottom-left-radius: 0;
			border-bottom-right-radius: 0;
			
			.icon {
				&:before {
					transform: rotate(180deg);
					display: block;
				}
			}
		}
		
		.dropdown-menu {
			border: 0;
			border-top: 0;
			border-radius: 0;
		}
	}
	
`

export default FilterDropdown